import { c as _c } from "react/compiler-runtime";
import styles from "./ToolTip.module.scss";
interface ToolIconProps {
  toggleTooltip: (state: boolean) => void;
  onClick: () => void;
}
export function ToolTipIcon(t0) {
  const $ = _c(10);
  const {
    toggleTooltip,
    onClick
  } = t0;
  let t1;
  let t2;
  if ($[0] !== toggleTooltip) {
    t1 = () => setTimeout(() => toggleTooltip(false), 10);
    t2 = () => setTimeout(() => toggleTooltip(true), 20);
    $[0] = toggleTooltip;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClick) {
    t3 = e_0 => {
      if (e_0.pointerType === "mouse") {
        onClick();
      } else {
        if (e_0.currentTarget === document.activeElement) {
          e_0.currentTarget.blur();
          e_0.preventDefault();
        } else {
          e_0.currentTarget.focus();
          e_0.preventDefault();
        }
      }
    };
    $[3] = onClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={styles.innerIcon}>?</div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t5 = <button name="Info om skattefradrag" type="button" className={styles.iconButton} onPointerEnter={_temp} onBlur={t1} onFocus={t2} onPointerDown={t3} onPointerLeave={_temp2}>{t4}</button>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp2(e_1) {
  if (e_1.pointerType === "mouse") {
    e_1.currentTarget.blur();
  }
}
function _temp(e) {
  if (e.pointerType === "mouse") {
    e.currentTarget.focus();
  }
}